module.exports = __webpack_public_path__ + "static/media/vda_logo.4b41652e.svg";